<template>
  <div>
    <v-card outlined class="rounded-card">
      <v-subheader>Produtos</v-subheader>
      <v-divider/>
      <v-list class="rounded-card">
        <template v-for="(produto, index) in produtos">
          <v-list-item :key="produto.id">
            <v-list-item-content>
              <v-list-item-title>
                <px-span-tooltip v-if="checkCodigo(produto.produto)"
                                             top
                                             :text="labelCodigo(produto.produto)"
                                             tooltip="Código do item"
                                             />
                {{ produto.produto.descricao }}
                </v-list-item-title>
              <v-list-item-subtitle>
                {{produto.quantidade | number(getCurrencyFormat(produto.produto.casasDecimais)) }}
                {{produto.unidadeMedida.descricao}}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <px-detalhes-produto
                :produto="produto"
                is-fornecedor
                show-obs-externa
                show-finalidade-compra
                show-data-previsao-entrega/>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index !== (produtos.length - 1)"
                     :key="`v-div${produto.id}`"/>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { CasaDecimalUtils } from 'px-components';

export default {
  props: {
    produtos: Array,
  },
  computed: {
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    labelCodigo() {
      return item => `${item.codigo} - `;
    },
    checkCodigo() {
      return item => item.codigo;
    },
  },
};
</script>
